module.exports = __webpack_public_path__ + "static/media/Charly.a3bf763a.png";